import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { ConfiguratorState, FormTypes, UpdateTableRowsUsers } from 'models/configurator';
import { RoleList } from 'models/request';
import { UsersResponse } from 'models/response';

const setUsers: CaseReducer<ConfiguratorState, PayloadAction<UsersResponse[]>> = (state, { payload }) => {
  state.users.users = payload;
};

const setSelectedUser: CaseReducer<ConfiguratorState, PayloadAction<UsersResponse | null>> = (state, { payload }) => {
  state.users.selectedUser = payload;
};

const setFormMode: CaseReducer<ConfiguratorState, PayloadAction<FormTypes>> = (
  state,
  { payload },
) => {
  state.users.formMode = payload;
};

const setImportUserKey: CaseReducer<ConfiguratorState, PayloadAction<number>> = (state, { payload }) => {
  state.users.importUserKey = payload;
};

const updateTableRows: CaseReducer<ConfiguratorState, PayloadAction<UpdateTableRowsUsers>> = (state, { payload }) => {
  // update rows based on property
  const newRows = state.users.users.map((row) => {
    if (payload.idUsers.includes(row.idUser)) {
      row[payload.property] = payload.value;
    }
    return row;
  });
  state.users.users = newRows;
};

const setUserRoles: CaseReducer<ConfiguratorState, PayloadAction<RoleList[]>> = (state, { payload }) => {
  state.users.userRoles = payload;
}

export default {
  setUsers,
  setSelectedUser,
  setFormMode,
  setImportUserKey,
  updateTableRows,
  setUserRoles,
};
